// Textos de los rechazos por empresa que comparten varias pantallas (UX-ERR-01).

/** no_active_company: el API solo lo responde si el usuario no tiene ninguna empresa,
 *  y entonces el encabezado no ofrece selector; no se le puede pedir que elija una. */
export const NO_COMPANY_TEXT =
  'Tu usuario no tiene una empresa asignada. Pide al administrador del sistema que te asigne una.';

/** active_company_forbidden: la empresa guardada en la app ya no es del usuario. */
export const ACTIVE_COMPANY_LOST_TEXT =
  'Ya no tienes acceso a la empresa seleccionada. Recarga la página y elige otra empresa en el encabezado.';

/** invalid_active_company_header: la empresa guardada en la app está mal formada. */
export const ACTIVE_COMPANY_INVALID_TEXT =
  'La empresa seleccionada no es válida. Recarga la página e intenta de nuevo.';
